<template>
    <div class="zhibu">
        <!-- 头部 -->
        <navbar-header :deptInfo="deptInfo"></navbar-header>
        <!-- 背景层 -->
        <div class="bg_box"></div>


        <!-- 主题内容 -->
        <banner-box></banner-box>

        <!-- 日历 -->
        <ri-li></ri-li>

        <!-- 会议列表 -->
        <meeting-list :deptId="deptInfo.deptId"></meeting-list>

        <nav-footer></nav-footer>
    </div>
</template>

<script>
    import BannerBox from "@/components/zhibu/BannerBox"
    import NavbarHeader from "@/components/zhibu/NavbarHeader"
    import RiLi from "@/components/zzsh/RiLi"
    import MeetingList from "@/components/zhibu/MeetingList"
    import NavFooter from "@/components/common/NavFooter"
    export default {
        components: {
            BannerBox,
            NavbarHeader,
            RiLi,
            MeetingList,
            NavFooter
        },
        data() {
            return {
                deptInfo: {}
            }
        },
        computed: {
            token () {
                return this.$store.getters.token
            },
            deptId () {
                return this.$route.params.id
            }
        },
        watch: {
            deptId () {
                this.getDeptInfo()
            }
        },
        mounted () {
            this.getDeptInfo()
        },
        methods: {
            // 获取支部信息
            async getDeptInfo () {
                this.deptInfo = {}
                let { token,deptId } = this 
                let res = await this.$axios.post("/lencon/pc/dept/detail", { token, deptId: Number(deptId) })
                if ( res.data.code == 1 ) {
                    this.deptInfo = res.data.obj
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
.zhibu {
    position: relative;
    left: 0;
    top: 0;
    .bg_box {
        width: 100%;
        height: 617px;
        background: url("../assets/static/zhibu/my_bg.jpg") 0 0 no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: 0;
        top: 240px;
        z-index: -1;
    }
}
</style>